import {V3Record} from 'data/helpers/V3Record.js'

export const Collection = V3Record('collection', {
  title: null, // string
  description: null, // string
  cover: null, // file
  userId: null, // integer
  showMap: null, // boolean
  visibility: null, // integer
  stats: {}, // {items: integer, distance: integer, elevation: integer}
  privacyCode: null, // string
  routeSetOverviewId: null, // integer
  updatedAt: null
}, {fileAttrs: ['cover'], readOnly: ['updatedAt']})
